export default [
  {
    path: '/corporate/company',
    name: 'Company',
    component: () => import('@/components/master/company/Company'),
    meta: {
      title: 'Company',
      requiresAuth: true,
      services: ['Company']
    }
  },
  {
    path: '/corporate/customer',
    name: 'Customer',
    component: () => import('@/components/master/customer/Customer'),
    meta: {
      title: 'Customer',
      requiresAuth: true,
      services: ['Customer']
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/corporateModule.js